import { Button, Spin, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import ActionConfirmationModal from 'src/app/shared/components/modal/action-confirmation-modal'
import { DangerAlertIcon, ModalWarningIcon } from 'src/assets/icons'
import { LoadingOutlined } from '@ant-design/icons'
import '../index.scss'
import { useEffect, useState } from 'react'
import { DEFAULT_ALL_ACCOUNTS } from '../constant'

interface IProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
  isWarning?: boolean
  hasIconWarning?: boolean
  getValues?: any
}

const Modal = (props: IProps) => {
  const { isOpen, onClose, onConfirm, isLoading = false, isWarning = false, hasIconWarning = false, getValues } = props
  const { t } = useTranslation()
  const [internalState, setInternalState] = useState({
    isWarning: false,
    hasIconWarning: false,
    isNotification: false,
  })
  const handleConfirm = () => {
    if (getValues('accountName') === DEFAULT_ALL_ACCOUNTS.value) {
      setInternalState({
        ...internalState,
        isNotification: true,
        hasIconWarning: true,
        isWarning: true,
      })
    } else {
      onConfirm?.()
    }
  }

  const handleClose = () => {
    setInternalState({
      ...internalState,
      isNotification: false,
      hasIconWarning: false,
      isWarning: false,
    })
    onClose?.()
  }

  useEffect(() => {
    setInternalState({ ...internalState, isWarning, hasIconWarning })
  }, [])

  return (
    <ActionConfirmationModal
      icon={internalState.hasIconWarning ? <ModalWarningIcon /> : <DangerAlertIcon />}
      title={
        <Typography className='modal-title'>
          {internalState.isWarning
            ? t('PurgeTransactions:popUp.warning.title')
            : t('PurgeTransactions:popUp.confirmation.title')}
        </Typography>
      }
      onClose={onClose}
      isOpen={isOpen}
      descriptionType='string'
      description={
        internalState.isWarning
          ? t('PurgeTransactions:popUp.warning.message')
          : t('PurgeTransactions:popUp.confirmation.message')
      }
      footer={
        !internalState.isNotification
          ? [
              <Button size='middle' onClick={handleClose} key={'cancel'}>
                {t('PurgeTransactions:popUp.button.cancel')}
              </Button>,
              <Button size='middle' type='primary' onClick={handleConfirm} key={'confirm'}>
                {isLoading ? (
                  <Spin
                    indicator={
                      <LoadingOutlined
                        style={{
                          color: 'white',
                        }}
                      />
                    }
                  />
                ) : (
                  t('PurgeTransactions:popUp.button.confirm')
                )}
              </Button>,
            ]
          : [
              <Button size='middle' type='primary' onClick={handleClose} key={'ok'}>
                {t('PurgeTransactions:popUp.button.ok')}
              </Button>,
            ]
      }
    />
  )
}

export default Modal
